import React from 'react';
import './resource-card.css';

const ResourceCard = ({ resource }) => {
    return (
        <div className="resource-card card h-100 shadow-sm">
            <div className="card-body d-flex flex-column">
                <div className="resource-img-container mb-3">
                    <img
                        className="resource-img"
                        src={resource.imgSrc}
                        alt={resource.name}
                    />
                </div>
                <h3 className="card-title h5 mb-3">{resource.name}</h3>
                <p className="card-text flex-grow-1 mb-4">
                    {resource.description}
                </p>
                <a
                    href={resource.url}
                    className="btn btn-outline-danger mt-auto"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Visit Site
                </a>
            </div>
        </div>
    );
};

export default ResourceCard;